<template>
    
</template>

<script>
    export default {
        name: "Manuscrits"
    }
</script>

<style scoped>

</style>